import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "StationCab - VTC & Taxi Paris",
  description = "Service de VTC et Taxi à Paris et Île-de-France. Réservation en ligne, tarifs transparents, chauffeurs professionnels. Aéroports CDG, Orly, gares parisiennes.",
  keywords = "VTC Paris, Taxi Paris, chauffeur privé, transfert aéroport CDG, Orly, réservation taxi, course VTC",
  image = "https://stationcab.fr/og-image.png",
  url = "https://stationcab.fr",
  type = "website"
}) => {
  const fullTitle = title.includes("StationCab") ? title : `${title} | StationCab`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="StationCab" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="geo.region" content="FR-IDF" />
      <meta name="geo.placename" content="Paris" />
      <meta name="language" content="French" />
    </Helmet>
  );
};

export default SEO;
